import React from 'react';
import { Check } from 'lucide-react';

// Reusable consent checkbox for all forms
const ConsentCheckbox = ({ checked, onChange, required = true }) => {
  return (
    <label className="flex items-start gap-3 cursor-pointer group" dir="rtl" data-testid="consent-checkbox-label">
      {/* Custom animated checkbox */}
      <div className="relative mt-1 flex-shrink-0">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          required={required}
          className="sr-only peer"
          data-testid="consent-checkbox"
        />
        <div 
          className={`
            w-5 h-5 border-2 rounded transition-all duration-300 ease-out cursor-pointer
            ${checked 
              ? 'bg-[#C5366A] border-[#C5366A] scale-110' 
              : 'bg-transparent border-[#6B6B6B] hover:border-[#C5366A]'
            }
            peer-focus-visible:ring-2 peer-focus-visible:ring-[#C5366A] peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-white
          `}
        >
          {/* Checkmark icon with animation */}
          <Check 
            className={`
              w-4 h-4 text-white absolute top-0.5 left-0.5
              transition-all duration-300
              ${checked 
                ? 'opacity-100 scale-100' 
                : 'opacity-0 scale-50'
              }
            `}
            strokeWidth={3}
          />
        </div>
        {/* Ripple effect on check */}
        <div 
          className={`
            absolute inset-0 rounded-full bg-[#C5366A]/30
            transition-all duration-500
            ${checked 
              ? 'scale-[2.5] opacity-0' 
              : 'scale-100 opacity-0'
            }
          `}
        />
      </div>
      <span className="text-[#6B6B6B] text-sm leading-relaxed group-hover:text-[#2D2D2D] transition-colors">
        אני מאשר/ת שקראתי את{' '}
        <a 
          href="/terms" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-[#C5366A] hover:underline"
          data-testid="terms-link"
        >
          התקנון
        </a>
        {' '}ואת{' '}
        <a 
          href="/privacy" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-[#C5366A] hover:underline"
          data-testid="privacy-link"
        >
          מדיניות הפרטיות
        </a>
        , ומסכים/ה לקבלת עדכונים, תכנים והצעות שיווקיות מ"המרכז הישראלי לעצמאות דיגיטלית" במייל, ב-SMS וב-WhatsApp.
      </span>
    </label>
  );
};

export default ConsentCheckbox;
